<template>
  <div class="charge-mgmt">
    <div class="main-title">
      <p>设备监控</p>
    </div>
    <div class="main-body">
      <div class="list">
        <span>时间：</span>
        <el-date-picker
          v-model="beginTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="开始日期">
        </el-date-picker>
        --
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="timestamp"
          placeholder="结束日期">
        </el-date-picker>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
      </div>
      <div class="box">
        <p class="sub-title">设备概览</p>
        <el-card shadow="hover" class="total-card">
          <div><p class="card-title">换电柜</p></div>
          <div class="number-box">
            <div class="number">{{ statistics3.all }}</div>
            <div class="text">总数</div>
            <div class="line"></div>
          </div>
          <div class="number-box">
            <div class="number">
              <el-progress class="progress" :stroke-width="4" :width="60" type="circle"
                           :percentage="statistics3.percentage1"
                           :show-text="false" status="exception">
              </el-progress>
              <div class="circle-number" style="color:#FF4949;">{{ statistics3.exception }}</div>
            </div>
            <div class="text">异常</div>
          </div>
          <div class="number-box">
            <div class="number">
              <el-progress class="progress" :stroke-width="4" :width="60" type="circle"
                           :percentage="statistics3.percentage2"
                           :show-text="false" color="#0069F4">
              </el-progress>
              <div class="circle-number" style="color:#0069F4;">{{ statistics3.normal }}</div>
            </div>
            <div class="text">正常</div>
          </div>
        </el-card>
        <el-card shadow="hover" class="total-card">
          <div><p class="card-title">电池</p></div>
          <div class="number-box">
            <div class="number">{{ statistics1.all }}</div>
            <div class="text">总数</div>
            <div class="line"></div>
          </div>
          <div class="number-box">
            <div class="number">
              <el-progress class="progress" :stroke-width="4" :width="60" type="circle"
                           :percentage="statistics1.percentage1"
                           :show-text="false" status="exception">
              </el-progress>
              <div class="circle-number" style="color:#FF4949;">{{ statistics1.exception }}</div>
            </div>
            <div class="text">异常</div>
          </div>
          <div class="number-box">
            <div class="number">
              <el-progress class="progress" :stroke-width="4" :width="60" type="circle"
                           :percentage="statistics1.percentage2"
                           :show-text="false" color="#0069F4">
              </el-progress>
              <div class="circle-number" style="color:#0069F4;">{{ statistics1.normal }}</div>
            </div>
            <div class="text">正常</div>
          </div>
        </el-card>
        <!--        <el-card shadow="hover" class="total-card">-->
        <!--          <div><p class="card-title">充电柜</p></div>-->
        <!--          <div class="number-box">-->
        <!--            <div class="number">4999</div>-->
        <!--            <div class="text">总数</div>-->
        <!--            <div class="line"></div>-->
        <!--          </div>-->
        <!--          <div class="number-box">-->
        <!--            <div class="number">-->
        <!--              <el-progress class="progress" :stroke-width="4" :width="60" type="circle" :percentage="20"-->
        <!--                           :show-text="false" status="exception">-->
        <!--              </el-progress>-->
        <!--              <div class="circle-number" style="color:#FF4949;">999</div>-->
        <!--            </div>-->
        <!--            <div class="text">异常</div>-->
        <!--          </div>-->
        <!--          <div class="number-box">-->
        <!--            <div class="number">-->
        <!--              <el-progress class="progress" :stroke-width="4" :width="60" type="circle" :percentage="80"-->
        <!--                           :show-text="false" color="#0069F4">-->
        <!--              </el-progress>-->
        <!--              <div class="circle-number" style="color:#0069F4;">4000</div>-->
        <!--            </div>-->
        <!--            <div class="text">正常</div>-->
        <!--          </div>-->
        <!--        </el-card>-->
      </div>
      <div class="box">
        <p class="sub-title">设备异常排行</p>
        <el-card shadow="hover" class="detail-card">
          <div>
            <p class="card-title">换电柜</p>
            <p class="top">TOP3</p>
          </div>
          <el-table
            :data="tableData3"
            style="width: 100%">
            <el-table-column
              prop="targetNumber"
              label="设备编号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="targetName"
              label="设备名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="ruleTypeStr"
              label="设备监控点"
              width="200">
            </el-table-column>
            <el-table-column
              prop="displayRuleContent"
              label="监控规则"
              width="380">
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="监控记录数"
              width="100">
            </el-table-column>
          </el-table>
        </el-card>
        <el-card shadow="hover" class="detail-card">
          <p class="card-title">电池</p>
          <p class="top">TOP3</p>
          <el-table
            :data="tableData1"
            style="width: 100%">
            <el-table-column
              prop="targetNumber"
              label="设备编号"
              width="180">
            </el-table-column>
            <el-table-column
              prop="targetName"
              label="设备名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="ruleTypeStr"
              label="设备监控点"
              width="200">
            </el-table-column>
            <el-table-column
              prop="displayRuleContent"
              label="监控规则"
              width="380">
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="监控记录数"
              width="100">
            </el-table-column>
          </el-table>
        </el-card>
        <!--        <el-card shadow="hover" class="detail-card">-->
        <!--          <p class="card-title">充电柜</p>-->
        <!--          <p class="top">TOP3</p>-->
        <!--          <el-table-->
        <!--            :data="tableData"-->
        <!--            style="width: 100%">-->
        <!--            <el-table-column-->
        <!--              prop="date"-->
        <!--              label="设备编号"-->
        <!--              width="100">-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              prop="name"-->
        <!--              label="设备名称"-->
        <!--              width="100">-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              prop="address"-->
        <!--              label="设备监控点"-->
        <!--              width="100">-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              prop="rule"-->
        <!--              label="监控规则"-->
        <!--              width="100">-->
        <!--            </el-table-column>-->
        <!--            <el-table-column-->
        <!--              prop="address"-->
        <!--              label="监控记录数"-->
        <!--              width="100">-->
        <!--            </el-table-column>-->
        <!--          </el-table>-->
        <!--        </el-card>-->
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../../utils/utils";

export default {
  name: 'warningOverview',
  data() {
    return {
      beginTime: '',
      endTime: '',
      statistics1: {},
      statistics3: {},
      tableData1: [],
      tableData3: [],
    }
  },
  mounted() {
    this.beginTime = new Date(Utils.getCurrentDate() + " 00:00").getTime();
    this.endTime = new Date(Utils.getCurrentDate() + " 23:59").getTime();
    this.queryStatics();
  },
  methods: {
    onQueryBtnClick() {
      this.queryStatics();
    },
    queryStatics: function () {
      this.queryEachStatistics(0);
      this.queryEachStatistics(3);
      this.queryEachTable(0);
      this.queryEachTable(3);
    },
    queryEachStatistics(number) {
      let self = this;
      let params = {
        targetType: number
      };
      this.$http.post('/managementPlatform/admin/monitorStatistics', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        res.mdata.percentage1 = parseInt(res.mdata.exception / res.mdata.all * 100);
        res.mdata.percentage2 = parseInt(res.mdata.normal / res.mdata.all * 100);
        if (number == 0) {
          self.statistics1 = res.mdata;
        }
        if (number == 3) {
          self.statistics3 = res.mdata;
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    queryEachTable(number) {
      let self = this;
      let params = {
        targetType: number,
        triggerStartTime: this.beginTime,
        triggerEndTime: this.endTime,
        beginIndex: 0,
        pageSize: 999
      };
      this.$http.post('/managementPlatform/admin/queryMonitorTriggerRecord', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        let list = res.mdata.rows;
        for (let i = 0; i < list.length - 1; i++) {
          for (let j = 0; j < list.length - i - 1; j++) {
            if (list[j].quantity < list[j + 1].quantity) {
              let temp = list[j];
              list[j] = list[j + 1];
              list[j + 1] = temp;
            }
          }
        }
        let shortList = [];
        let obj = {};
        for (let j = 0; j < list.length; j++) {
          if (obj[list[j].targetNumber]) continue;
          else {
            obj[list[j].targetNumber] = list[j];
            shortList.push(list[j]);
          }
        }

        if (number == 0) {
          self.tableData1 = shortList.slice(0, 3);
        }
        if (number == 3) {
          self.tableData3 = shortList.slice(0, 3);
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    formatTime2(time) {
      let timeStr = '';
      let timeFloat = parseFloat(time);
      var hours = parseInt(timeFloat / (1000 * 60 * 60));
      var minutes = parseInt((timeFloat % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = (timeFloat % (1000 * 60)) / 1000;
      if (seconds) {
        timeStr += seconds + '秒';
      }
      if (minutes) {
        timeStr += minutes + '分钟';
      }
      if (hours) {
        timeStr += hours + '小时';
      }
      return timeStr;
    },
  },
}
</script>

<style lang="scss" scoped>
.main-body {
  width: 1140px;

  .box {
    overflow: hidden;
  }

  .sub-title {
    font-weight: bold;
    margin-top: 20px;
  }

  .total-card {
    margin: 20px 20px 5px 0;
    float: left;

    .number-box {
      display: inline-block;
      margin: 10px 0;
      padding: 0 20px;
      width: 60px;
      text-align: center;
      position: relative;

      .number {
        margin-bottom: 10px;
        line-height: 60px;
        font-size: 18px;

        .progress {
          vertical-align: middle;
        }
      }

      .circle-number {
        width: 60px;
        position: absolute;
        font-size: 18px;
        top: 2px;
      }

      .line {
        position: absolute;
        height: 30px;
        width: 1px;
        background-color: #E6E6E6;
        right: 0;
        top: 10px;
      }
    }
  }

  .detail-card {
    width: 1083px;
    min-height: 150px;
    margin: 20px 20px 0 0;
    float: left;

    .top {
      float: right;
      color: #FF4949;
      font-weight: bold;
    }
  }

  .card-title {
    display: inline-block;
    font-weight: bold;
    text-align: left;
    border-bottom: 5px solid #89c647;
  }
}

</style>
<style>
.el-table .cell {
  padding: 0 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/warningOverview.vue